import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

/**
 * Standalone child component wrapping the user avatar + mat-menu dropdown.
 * Uses Default CD so the mat-menu trigger overlay is not torn down by
 * the parent's OnPush change detection.
 *
 * All boolean inputs are pre-gated by the parent Header: they already
 * incorporate environment flags, remote-config state, and user roles.
 */
@Component({
  selector: 'app-user-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [RouterLink, CommonModule, MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule],
  templateUrl: './user-menu.html',
  styleUrl: './header.scss',
})
export class UserMenu {
  readonly userImage = input<string | null>(null);
  readonly userDisplayName = input('');
  readonly userEmail = input('');
  readonly accountRoleLabel = input('');

  // Pre-gated visibilities (env + role + remote-config already combined by parent)
  readonly showAdminItems = input(false);
  readonly showAdminRestricted = input(false);
  readonly showProviderMenu = input(false);
  readonly showAIModels = input(false);
  readonly showAIAgents = input(false);
  readonly imageErrored = input(false);

  readonly logout = output();
  readonly clearImage = output();
}
